import { ForecastParameterDetailBase } from './base/forecast-parameter-detail-base';

export class ForecastParameterDetail extends ForecastParameterDetailBase { }